var render = function render(){var _vm=this,_c=_vm._self._c;return _c('component-module',{attrs:{"moduleName":"dashboard_module"},scopedSlots:_vm._u([{key:"programName",fn:function(){return [_vm._v("Dashboard")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }